export const indexChartLabels = [
  'Rezzil Index',
  'Composure',
  'Reaction',
  'Accuracy',
  'Completeness',
];
